/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChefEntrepriseDisplayNameDto
 */
export interface ChefEntrepriseDisplayNameDto {
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseDisplayNameDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseDisplayNameDto
     */
    text?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseDisplayNameDto
     */
    idchefEntrepriseSiege?: number | null;
}

/**
 * Check if a given object implements the ChefEntrepriseDisplayNameDto interface.
 */
export function instanceOfChefEntrepriseDisplayNameDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseDisplayNameDtoFromJSON(json: any): ChefEntrepriseDisplayNameDto {
    return ChefEntrepriseDisplayNameDtoFromJSONTyped(json, false);
}

export function ChefEntrepriseDisplayNameDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseDisplayNameDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'idchefEntrepriseSiege': !exists(json, 'idchefEntrepriseSiege') ? undefined : json['idchefEntrepriseSiege'],
    };
}

export function ChefEntrepriseDisplayNameDtoToJSON(value?: ChefEntrepriseDisplayNameDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'text': value.text,
        'idchefEntrepriseSiege': value.idchefEntrepriseSiege,
    };
}

